import { NavLink } from 'react-router-dom';

function Header() {
  return (
    <div className='flex flex-col w-full h-[150px]'>
      <div className='flex justify-center items-center h-[100px] w-full'>
        <NavLink to="/">
          <img src={'/assets/img/logo.png'} style={{ width: '200px', height: 'auto' }} alt="Logo" />
        </NavLink>
      </div>

      <div className='flex w-full justify-center space-x-[13px]'>
        <NavLink
          to="/products"
          className={({ isActive }) => isActive ? "font-bold" : ""}
        >
          Products
        </NavLink>
        <span> |</span>

        <NavLink
          to="/team"
          className={({ isActive }) => isActive ? "font-bold" : ""}
        >
          About/Team
        </NavLink>
        <span> |</span>

        <NavLink
          to="/contact"
          className={({ isActive }) => isActive ? "font-bold" : ""}
        >
          Contact
        </NavLink>
      </div>

      <div className='w-full h-[50px]'></div>
    </div>
  );
}

export default Header;
